var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Lernmaterial aus Ablaufplan-Themen erstellen"),
      confirmText: _vm.$gettext("Erstellen"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Abbrechen"),
      closeClass: "cancel",
      height: "450",
      width: "500",
    },
    on: {
      close: function close($event) {
        return _vm.setShowUnitTopicsDialog(false)
      },
      confirm: _vm.createUnit,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "courseware-collapsible-box",
                  {
                    attrs: {
                      title: _vm.$gettext("Grundeinstellungen"),
                      open: true,
                    },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "studiprequired",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.text.title) +
                            "\n                    "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "asterisk",
                            attrs: {
                              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                              "aria-hidden": "true",
                            },
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title,
                              expression: "title",
                            },
                          ],
                          attrs: {
                            type: "text",
                            required: "",
                          },
                          domProps: {
                            value: _vm.title,
                          },
                          on: {
                            input: function input($event) {
                              if ($event.target.composing) return
                              _vm.title = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "studiprequired",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.text.description) +
                            "\n                    "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "asterisk",
                            attrs: {
                              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                              "aria-hidden": "true",
                            },
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.description,
                              expression: "description",
                            },
                          ],
                          attrs: {
                            required: "",
                          },
                          domProps: {
                            value: _vm.description,
                          },
                          on: {
                            input: function input($event) {
                              if ($event.target.composing) return
                              _vm.description = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "courseware-collapsible-box",
                  {
                    attrs: {
                      title: _vm.$gettext("Darstellung"),
                    },
                  },
                  [
                    _c(
                      "label",
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Bild hochladen")) +
                            "\n                    "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("input", {
                          ref: "upload_image",
                          staticClass: "cw-file-input",
                          attrs: {
                            type: "file",
                            accept: "image/*",
                          },
                          on: {
                            change: _vm.checkUploadFile,
                          },
                        }),
                        _vm._v(" "),
                        _vm.uploadFileError
                          ? _c("CoursewareCompanionBox", {
                              staticClass: "cw-companion-box-in-form",
                              attrs: {
                                msgCompanion: _vm.uploadFileError,
                                mood: "sad",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedStockImage
                      ? [
                          _c("StockImageSelectableImageCard", {
                            attrs: {
                              "stock-image": _vm.selectedStockImage,
                            },
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                attrs: {
                                  type: "button",
                                },
                                on: {
                                  click: function click($event) {
                                    _vm.selectedStockImage = null
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$gettext("Bild entfernen")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      : _c(
                          "label",
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("oder")) +
                                "\n                    "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                attrs: {
                                  type: "button",
                                },
                                on: {
                                  click: function click($event) {
                                    _vm.showStockImageSelector = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Aus dem Bilderpool auswählen"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showStockImageSelector
                              ? _c("StockImageSelector", {
                                  on: {
                                    close: function close($event) {
                                      _vm.showStockImageSelector = false
                                    },
                                    select: _vm.onSelectStockImage,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "label",
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Farbe")) +
                            "\n                    "
                        ),
                        _c("studip-select", {
                          attrs: {
                            options: _vm.colors,
                            reduce: function reduce(color) {
                              return color.class
                            },
                            label: "name",
                            clearable: false,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "open-indicator",
                              fn: function fn(selectAttributes) {
                                return [
                                  _c(
                                    "span",
                                    _vm._b({}, "span", selectAttributes, false),
                                    [
                                      _c("studip-icon", {
                                        attrs: {
                                          shape: "arr_1down",
                                          size: 10,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "no-options",
                              fn: function fn() {
                                return [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Es steht keine Auswahl zur Verfügung."
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "selected-option",
                              fn: function fn(option) {
                                return [
                                  _c("span", {
                                    staticClass: "vs__option-color",
                                    style: {
                                      "background-color": option.hex,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.name))]),
                                ]
                              },
                            },
                            {
                              key: "option",
                              fn: function fn(option) {
                                return [
                                  _c("span", {
                                    staticClass: "vs__option-color",
                                    style: {
                                      "background-color": option.hex,
                                    },
                                  }),
                                  _c("span", [_vm._v(_vm._s(option.name))]),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.color,
                            callback: function callback($$v) {
                              _vm.color = $$v
                            },
                            expression: "color",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }